<template>
  <v-card flat class="searchAi-container custom-scrollbar" height="100%" style="background-color: #f9fcff">
    <SearchAIHeader></SearchAIHeader>
    <v-card-text class="searchAi-content mt-4">
      <ResearchQuestionInput />
      <ResearchQuestionDisplay />
      <KeyConceptSection />
      <KeywordsContainer />
      <SearchAIFooter />
    </v-card-text>
  </v-card>
</template>

<script>
import SearchAIHeader from './SearchAIHeader.vue'
import ResearchQuestionInput from './ResearchQuestionInput.vue'
import ResearchQuestionDisplay from './ResearchQuestionDisplay.vue'
import KeyConceptSection from './KeyConceptSection.vue'
import KeywordsContainer from './KeywordsContainer.vue'
import SearchAIFooter from './SearchAIFooter.vue'

export default {
  name: 'screenTwo',
  components: {
    SearchAIHeader,
    ResearchQuestionInput,
    ResearchQuestionDisplay,
    KeyConceptSection,
    KeywordsContainer,
    SearchAIFooter
  }
}
</script>

<style scoped lang="scss">
.searchAi {
  &-container {
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0 36px;
    display: flex;
    flex-direction: column;
    background-color: $bg-primary;
  }
  &-content {
    padding: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/searchAi/SearchAIContainer.vue